import { render, staticRenderFns } from "./CardSnugglepot.vue?vue&type=template&id=15dafc93&"
import script from "./CardSnugglepot.vue?vue&type=script&lang=js&"
export * from "./CardSnugglepot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports